"use client";

import type { UserId } from "@nimble/datamodel/types/userId";
import { Loader } from "@nimble/react-requests/components/shared/loader";
import { useRouter } from "next/navigation";
import React, { useEffect } from "react";

import { useIsQuizComplete } from "@/hooks/quiz/use-quiz";
import routes from "@/lib/routes";

type QuizCompleteRedirectGateProps = {
  userId: UserId;
  disabled: boolean;
  children: React.ReactNode;
};

const QuizCompleteRedirectGateLoader = () => {
  return (
    <div className="mx-auto max-w-md mt-6">
      <div className="flex justify-center">
        <Loader />
      </div>
    </div>
  );
};

export function QuizCompleteRedirectGate({
  userId,
  disabled,
  children,
}: QuizCompleteRedirectGateProps) {
  const router = useRouter();
  const { quizComplete, quizStatusQuery } = useIsQuizComplete(userId);

  const isLoading = quizStatusQuery.isPending;

  useEffect(() => {
    if (disabled) return;
    if (!isLoading && quizComplete) {
      router.replace(routes.getQuizResults());
    }
  }, [disabled, isLoading, quizComplete, router]);

  if (isLoading || (!disabled && quizComplete)) {
    return <QuizCompleteRedirectGateLoader />;
  }

  return <>{children}</>;
}
